import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12 22C6.47967 21.9939 2.00606 17.5203 2 12V11.8C2.10993 6.30452 6.63459 1.92794 12.1307 2.00087C17.6268 2.07379 22.0337 6.56887 21.9978 12.0653C21.9619 17.5618 17.4966 21.9989 12 22ZM12 3.99999C7.58172 3.99999 4 7.58171 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C19.995 7.58377 16.4162 4.00495 12 3.99999ZM10.55 17L9.136 15.585L12.671 12.05L9.136 8.51499L10.55 7.09999L15.5 12.05L10.551 17H10.55Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "CircleChevronRight"
);
